import { Container } from '@ui/wrapper'
import { SectionWrapper, StyledText } from './style'

const ImpressumArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data?.texts?.map((text, i) => (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: text.content
            }}
            key={i}
          />
        ))}
      </Container>
    </SectionWrapper>
  )
}

export default ImpressumArea
